<template>
  <div>
    <b-row>
      <div class="ml-auto mb-2 mr-3">
        <label class="mr-1 h7 mt-1"> {{ $t("training-view.extract") }} </label>
        <b-button class="esep-blue-bg float-right my-auto" @click.prevent="downloadItem">
          Excel
        </b-button>
      </div>
    </b-row>
    <b-card no-body>
      <b-tabs active-nav-item-class="font-weight-bold" card>
        <b-tab  
          :title="$t('training-view.permission')" 
          title-link-class="text-dark" 
          active
          >
          <training-license-form :activity="activity" v-on:error:api.capture="emitError" 
            @activity-saved="emitSuccess" @leaders-changed="leadersChanged"/>
        </b-tab>
        <b-tab  
          :title="$t('training-view.trainers')" 
          title-link-class="text-dark"
          lazy
          v-if="isTrainer || isAdmin"
          >
          <training-trainers :activity="activity"  v-on:error:api.capture="emitError" @leaders-changed="leadersChanged"/>
        </b-tab>
        <b-tab  
          :title="$t('training-view.trainees')" 
          title-link-class="text-dark"
          lazy
          v-if="isTrainer || isAdmin"
          >
          <training-trainees :activity="activity" v-on:error:api.capture="emitError"/>
        </b-tab>
        <b-tab  
          :title="$t('training-view.topics')" 
          title-link-class="text-dark"
          lazy
          v-if="isTrainer || isAdmin"
          >
          <training-topics :activity="activity" :sessions="sessions" v-if="sessions != null" 
            v-on:error:api.capture="emitError" @refresh-sessions="getActivitysSessions"/>
        </b-tab>
        <b-tab  
          :title="$t('training-view.budget')" 
          title-link-class="text-dark" 
          v-if='activity.module.billMethod.rules[0] && (activity.module.billMethod.rules[0].billingValue / 100) > 0 && (isTrainer || isAdmin)'
          lazy
          >
          <training-budget :activity="activity" v-on:error:api.capture="emitError"/>
        </b-tab>
        <b-tab  
          :title="$t('training-view.evaluationTotal')" 
          title-link-class="text-dark"
          lazy
          v-if="isTrainer || isAdmin"
          >
          <training-evaluation-total :activity="activity" v-on:error:api.capture="emitError"/>
        </b-tab>
        <b-tab  
          :title="$t('training-view.evaluation')" 
          title-link-class="text-dark"
          lazy
          v-if="isTrainer || isAdmin"
          >
          <training-evaluation :activity="activity" :sessions="sessions" v-if="sessions != null"
             v-on:error:api.capture="emitError"/>
        </b-tab>
        <b-tab
            title-link-class="text-dark"
            lazy
            v-if="(isTrainer || isAdmin) && activity.status === 'APPROVED'"
        >
          <template slot="title">
            {{ $t('evaluations.trainerEvaluationsTitle') }}
            <b-badge style="margin-right: 2em;" v-if="evaluationsCount" :variant="evaluationsCount/criteriaCount===0? 'danger': evaluationsCount/criteriaCount===1? 'success': 'warning'"> {{ evaluationsCount }} / {{ criteriaCount }} </b-badge>
          </template>
          <trainer-evaluation :activity="activity" v-on:error:api.capture="emitError" :leaders="evalLeadersList" v-on:updateEvals.capture="getTrainerEvaluations" :can-submit="isTrainer"/>
        </b-tab>
        <b-tab  
          :title="$t('training-view.review')" 
          title-link-class="text-dark"
          v-if='activity.module.billMethod.rules[0] && (activity.module.billMethod.rules[0].billingValue > 0) && (isTrainer || isAdmin)'
          lazy
          >
          <training-budget-review :activity="activity" v-on:error:api.capture="emitError"/>
        </b-tab>
        <b-tab  
          :title="$t('training-view.denials')" 
          title-link-class="text-dark"
          lazy
          v-if="isTrainer || isAdmin"
          >
          <training-denials :activity="activity" v-on:error:api.capture="emitError"/>
        </b-tab>
        <b-tab
            :title="$t('training-view.apply-activities')"
            title-link-class="text-dark"
            lazy
            v-if="(isTrainer || isAdmin) && activity.module.applyMethod === 'IN_TRAINING'"
        >
          <training-apply-activities :activity="activity" v-on:error:api.capture="emitError"/>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import trainingService from "../../services/training.service";
import {handleApiError, makeErrorToast} from "../../services/error.service";
import TrainingLicenseForm from '../../components/training/trainingLicenseForm'
import TrainingBudget from './trainingBudget.vue'
import TrainingBudgetReview from './trainingBudgetReview.vue'
import TrainingEvaluation from './trainingEvaluation.vue'
import TrainingEvaluationTotal from './trainingEvaluationTotal.vue'
import TrainingTopics from './trainingTopics.vue'
import TrainingTrainees from './trainingTrainees.vue'
import TrainingTrainers from './trainingTrainers.vue'
import TrainingDenials from './trainingDenials.vue';
import TrainingApplyActivities from "@/components/training/trainingApplyActivities";
import trainerEvaluation from "@/components/evaluations/TrainerEvaluation";

export default {
  computed: {
    isAdmin() {
      let isAdmin = false;
      let userInfo = this.$store.state.userInfo
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "ADMIN" || userInfo.roles[i].name == 'TRAINING_ADMIN') {
          isAdmin = true;
        }
      }
      return isAdmin;
    },
    isMod() {
      let isMod = false;
      let userInfo = this.$store.state.userInfo
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "TRAIN_MOD") {
          isMod = true;
        }
      }
      return isMod;
    },
    isTrainer() {
      let isTrainer = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "TRAINER") {
          this.activity.leaders.forEach(leader => {
            if(userInfo.id == leader.member?.id && leader.position == 'LEADER'){
              isTrainer = true;
            }
          });
        }
      }
      return isTrainer;
    }
  },
  props: {
    activity: {
      type: Object
    }
  },
  components: {
    TrainingApplyActivities,
    TrainingLicenseForm,
    TrainingTrainers,
    TrainingTopics,
    TrainingBudget,
    TrainingEvaluationTotal,
    TrainingEvaluation,
    TrainingTrainees,
    TrainingBudgetReview,
    TrainingDenials,
    trainerEvaluation
  },
  mounted() {
    this.getActivitysSessions();
    this.getTrainerEvaluations()
  },
  data() {
    return {
      evaluationsCount: null,
      criteriaCount: null,
      evalLeadersList: [],
      training: {
        trainers: [
          {id: 2014207 , 
          fullName: "ΓΙΟΒΑΝΟΠΟΥΛΟΣ ΖΗΣΗΣ",
          leaderType: "INSTRUCTOR",
          partTime: true
          }
        ],
        sessions: [],
        accountItems: [],
        evalTotal: [
          {title: "1.01 Εκπαιδευτική Διαδικασία - Τήρηση Προγράμματος" , value: 4.5}
        ],
        evalAverage: 4.5,
        evalNeeded: 34,
        evalDone: 31,
        eval: [
          {title: "1.01 Εκπαιδευτική Διαδικασία - Τήρηση Προγράμματος" , value: 4.9}
        ],
        trainees: [
          {id: 2014207 , 
          fullName: "ΓΙΟΒΑΝΟΠΟΥΛΟΣ ΖΗΣΗΣ",
          phone: "6969696969",
          mobile: "6969696969",
          denialReason: "ΜΑΛΑΚΙΑ"
          }
        ],
        budgetReview: []
      },
      sessions: null,
    }    
  },
  methods: {
    emitError(errorMessage) {
      this.$emit('error:api', errorMessage);
    },
    emitSuccess(successMessage) {
      this.$emit('success', successMessage);
    },
    leadersChanged(leaders) {
      this.$emit('leaders-changed', leaders);
    },
    getActivitysSessions() {
      trainingService.getActivitysSessions(this.activity.id).then(
        (response) => {
          this.$log.debug("sessions")
          this.$log.debug(response.data);
          this.sessions = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getTrainerEvaluations() {
      trainingService.getLeaderEvaluationInfo(this.activity.id).then(
          (response) => {
            this.evalLeadersList = response.data.leaders.filter(l=>l.position!=='LEADER');
            this.evaluationsCount = this.evalLeadersList.reduce((accumulator, object) => {return accumulator + (object.evaluationsCount === object.criteriaCount); }, 0);
            this.criteriaCount = this.evalLeadersList?.length;
          },
          (error) => {
            makeErrorToast(this.$bvToast, error);
          }
      )
    },
    downloadItem() {
      this.$emit('download-report');
    }
  }
}
</script>
